import { Grid, TextField, Theme } from "@mui/material";
import { FC } from "react";
import { makeStyles } from "@mui/styles";
import { KeyCard } from "./key-card";
import { AssignKeyContentProps } from "./assign-key-content.types";
import { Paragraph } from "../typography";

const useStyles = makeStyles((theme: Theme) => ({
  keyIcon: {
    fontSize: 150,
    color: theme.palette.secondary.main
  },
  cardWrapper: {
    border: `10px solid ${theme.palette.secondary.main}`,
    borderRadius: 20,
    width: 350,
    minHeight: 200
  },
  cardDivider: {
    borderTop: `10px solid ${theme.palette.secondary.main}`
  },
  fallbackContainer: {
    height: "100%",
    marginTop: theme.spacing(1)
  }
}));

export const AssignKeyContent: FC<AssignKeyContentProps> = ({
  isKeyAssigned,
  isError,
  unitName,
  labels,
  isConnecting,
  isWaiting,
  isAborted,
  assignKeyAnimation,
  assignKeyAnimationRunning,
  cardNumberValue,
  onChangeCardNumber,
  PropertyLogo,
  KeyProviderLogo
}) => {
  const classes = useStyles();

  return (
    <Grid container alignItems="center" justifyContent="center">
      {isKeyAssigned && (
        <KeyCard
          unitName={unitName}
          labels={labels}
          PropertyLogo={PropertyLogo}
          KeyProvideLogo={KeyProviderLogo}
        />
      )}
      {isConnecting && assignKeyAnimation}
      {isWaiting && assignKeyAnimationRunning}
      {(isError || isAborted) && (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          className={classes.fallbackContainer}
        >
          <Paragraph sx={{ color: "error.main" }} mb={2}>
            <span>{labels.cardNumberDescription} </span>
          </Paragraph>
          <TextField
            value={cardNumberValue}
            onChange={onChangeCardNumber}
            label={labels.cardNumber}
            variant="filled"
            fullWidth
          />
        </Grid>
      )}
    </Grid>
  );
};
